import { useState } from "react";
import { Button, TextField } from "@mui/material";
import "../../../styles/StartAConversation.css";
import TabLayout from "../../../lib/bandung/components/helpers/TabLayout";

function ProfileSettingsContactInfoTab() {
  const [url, setUrl] = useState("");

  const handleChange = (e) => setUrl(e.target.value);

  // return (
  //   <div className="Inputs w-96 h-96 relative">
  //     <div className="InputFieldWithLabel w-72 h-20 left-[339px] top-[170px] absolute flex-col justify-start items-start gap-2 inline-flex">
  //       <div className="Password self-stretch  text-base font-medium font-['Inter'] leading-normal">Password</div>
  //       <div className="Field px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 justify-start items-start gap-2 inline-flex">
  //         <div className="Label w-64 text-zinc-500 text-base font-medium font-['Inter'] leading-normal">Enter password</div>
  //       </div>
  //     </div>
  //     <div className="InputFieldWithLabel w-72 h-20 left-[339px] top-[263px] absolute flex-col justify-start items-start gap-2 inline-flex">
  //       <div className="Email self-stretch  text-base font-medium font-['Inter'] leading-normal">Email</div>
  //       <div className="Field px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 justify-start items-start gap-2 inline-flex">
  //         <div className="Label w-64 text-zinc-500 text-base font-medium font-['Inter'] leading-normal">Enter email</div>
  //       </div>
  //     </div>
  //     <div className="InputFieldWithLabel w-72 h-20 left-[339px] top-[359px] absolute flex-col justify-start items-start gap-2 inline-flex">
  //       <div className="PhoneNumber self-stretch  text-base font-medium font-['Inter'] leading-normal">Phone Number</div>
  //       <div className="Field px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 justify-start items-start gap-2 inline-flex">
  //         <div className="Label w-64 text-zinc-500 text-base font-medium font-['Inter'] leading-normal">Enter phone number</div>
  //       </div>
  //     </div>
  //     <div className="Username w-72 left-[341px] top-[74px] absolute  text-base font-medium font-['Inter'] leading-normal">Username</div>
  //     <div className="Field w-72 h-12 px-4 py-3 left-[341px] top-[106px] absolute bg-white rounded-lg shadow border border-neutral-200 justify-start items-start gap-2 inline-flex">
  //       <div className="Label w-64 text-zinc-500 text-base font-medium font-['Inter'] leading-normal">Enter username</div>
  //     </div>

  //     <div className="ProfileContactInformation w-80 h-5 left-[314px] top-0 absolute text-2xl font-bold font-['Inter'] leading-normal whitespace-nowrap">Profile: Contact Information</div>

  //     <div className="ChangesAppliedSuccessfully   left-[341px] top-[500px] absolute text-sky-800 text-base font-medium font-['Inter'] leading-normal whitespace-nowrap">Changes Applied Successfully</div>
  //     <div className="CannotSaveChangesFillOutRequiredFields  left-[341px] top-[529px] absolute text-rose-800 text-base font-medium font-['Inter'] leading-normal whitespace-nowrap">Cannot save changes. Fill out required fields.</div>


  //     <div className="Button w-60 h-12 px-6 py-3.5 left-[341px] top-[600px] absolute bg-rose-800 rounded-lg shadow justify-center items-center gap-2 inline-flex">
  //       <div className="ApplyAndSaveChanges text-white text-base font-medium font-['Inter'] leading-normal">Apply and Save Changes</div>
  //     </div>
  //   </div>


  // );



  return (

  
    <div className="Inputs w-96 h-auto flex flex-col  justify-center  space-y-6 mx-auto"> {/* Centering and spacing */}
      <div className="ProfileContactInformation w-80 text-2xl font-bold font-['Inter'] leading-normal whitespace-nowrap text-center">
      Profile: Contact Information
      </div>
  
      <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
        <div className="Email text-base font-medium font-['Inter'] leading-normal">Username</div>
        <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
          <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
            Enter username
          </div>
        </div>
      </div>
  
      <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
        <div className="Email text-base font-medium font-['Inter'] leading-normal">Email</div>
        <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
          <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
            Enter email
          </div>
        </div>
      </div>
  
      <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
        <div className="Password text-base font-medium font-['Inter'] leading-normal">Password</div>
        <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
          <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
            Enter password
          </div>
        </div>
      </div>
  
      <div className="InputFieldWithLabel w-full flex flex-col space-y-2">
        <div className="Password text-base font-medium font-['Inter'] leading-normal">Phone Number</div>
        <div className="Field w-full px-4 py-3 bg-white rounded-lg shadow border border-neutral-200 flex items-center">
          <div className="Label w-full text-zinc-500 text-base font-medium font-['Inter'] leading-normal">
            Enter phone number
          </div>
        </div>
      </div>
  
      <div className="SaveButton">
        <div className="Button w-45 px-4  py-3.5 bg-rose-800 rounded-lg shadow flex justify-center items-center">
          <div className="ApplyAndSaveChanges text-white text-base font-medium font-['Inter'] leading-normal">
            Apply and Save Changes
          </div>
        </div>
      </div>
    </div>
  );


}

export default ProfileSettingsContactInfoTab;
